import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setMasterFormAction, selectAction } from "../../redux/rootReducer";
import { MASTER_FORM_INITIAL, SELECT_INITIAL } from "../../redux/initialStateConstant";
import Select from "../Select/Select";
import { UpdateMasterThunk } from "../../redux/thunks/UpdateMasterThunk";

const MasterForm = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const master_form = useSelector(state => state.master_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => {
                            dispatch(setMasterFormAction(MASTER_FORM_INITIAL));
                        } }/>
                        <div className="form__title">Мастер</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Имя мастера</div>
                        <input type="text" className="input"
                            value={ master_form.name }
                            onInput={ event => {
                                dispatch(setMasterFormAction({
                                    ...master_form,
                                    name: event.target.value
                                }));
                            } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Специализация</div>
                        <Select
                            current={ master_form.specialization.name }
                            type={ 'master_specialization' }
                            options={ services_settings.specializations }
                            handler={ (elem) => {
                                dispatch(setMasterFormAction({
                                    ...master_form,
                                    specialization: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                        />
                    </div>

                    <div className="form__field">
                        <div className="button button--green"
                            onClick={ () => {
                                dispatch(UpdateMasterThunk({
                                    master_id: master_form.id,
                                    name: master_form.name,
                                    specialization_id: master_form.specialization.id
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MasterForm;